if (!customElements.get('collection-layout-option')) {
  customElements.define(
    'collection-layout-option',
    class CollectionLayoutOption extends HTMLElement {
      static STORAGE_KEY = 'collectionLayoutPreference';
      static observerAttached = false;

      constructor() {
        super();
        this.addEventListener('click', this.switchLayout.bind(this));
      }

      connectedCallback() {
        const stored = CollectionLayoutOption.getStoredLayout();
        const input = this.querySelector(`input[type="radio"][value="${stored}"]`);
        if (input) input.checked = true;
        CollectionLayoutOption.applyLayoutToGrid(stored);
        CollectionLayoutOption.observeGrid();
      }

      switchLayout() {
        const checked = this.querySelector('input[type="radio"]:checked');
        if (!checked) return;
        const value = checked.value;

        CollectionLayoutOption.setStoredLayout(value);
        CollectionLayoutOption.syncRadios(value);
        CollectionLayoutOption.applyLayoutToGrid(value);
      }

      static getStoredLayout() {
        try {
          return localStorage.getItem(CollectionLayoutOption.STORAGE_KEY) || 'grid';
        } catch (e) {
          return 'grid';
        }
      }

      static setStoredLayout(value) {
        try {
          localStorage.setItem(CollectionLayoutOption.STORAGE_KEY, value);
        } catch (e) {}
      }

      static applyLayoutToGrid(value) {
        const productGrid = document.querySelector('[id="product-grid"]');
        if (!productGrid) return;

        if (value === 'list') {
          productGrid.classList.remove('layout_grid');
          productGrid.classList.add('layout_list');
        } else {
          productGrid.classList.remove('layout_list');
          productGrid.classList.add('layout_grid');
        }
      }

      static syncRadios(value) {
        document.querySelectorAll('collection-layout-option input[type="radio"]').forEach((input) => {
          input.checked = input.value === value;
        });
      }

      // Reapply persisted layout whenever the product grid is re-rendered
      // (e.g. after filter, sort, or show-by changes from Klevu or Shopify facets).
      static observeGrid() {
        if (CollectionLayoutOption.observerAttached) return;
        const container = document.getElementById('ProductGridContainer');
        if (!container) return;

        const observer = new MutationObserver(() => {
          CollectionLayoutOption.applyLayoutToGrid(CollectionLayoutOption.getStoredLayout());
        });

        observer.observe(container, { childList: true, subtree: true });
        CollectionLayoutOption.observerAttached = true;
      }
    }
  );
}